var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mb-3"},[_c('dashboard-notification-menu-notification',{attrs:{"notification":_vm.notification,"in-toast-context":"","is-first":""},on:{"toggleReadClick":_vm.toggleReadClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }